var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app-bar',{attrs:{"fixed":"","color":"dark","elevation":"1","app":"","dark":""}},[_c('v-img',{staticClass:"mr-5",attrs:{"src":require("../../assets/main-logo.png"),"max-width":"100"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }